export default __webpack_public_path__ + "static/media/Cermak.48312c01.png";